const projects = [
  {
    id: 1,
    name: "Todo List",
    url: "https://todoollist.netlify.app/",
    background: "",
  },
  {
    id: 2,
    name: "Gerenciador",
    url: "https://gerenciadorm.netlify.app/",
    background: "../../assets/gerenciador.jpg",
  },
];
module.exports = projects;
